/**
 * Gibbs results-interpretation layer — post-workflow decision support.
 *
 * Three utility modules:
 * - compoundRanker: ranks loaded compounds by score + flags + interactions
 * - decisionRationale: produces per-compound structured "why this rank" record
 * - pathsNotTaken: suggests reachable registry actions the plan did not run
 *
 * Consumed by the ResultsPane UI (ui/dialog/ResultsPane/) and the
 * ChatBot ResultCard component. Pure utilities — no React, no event
 * broker coupling.
 *
 * See labwork/studies/gibbs-results-interpretation-layer/ for design
 * context.
 *
 * @module gibbs/results
 */

export {
    rankCompounds,
    defaultWeights,
} from './compoundRanker';

export {
    generateFor,
    generateGroundedFor,
    DECISION_RATIONALE_SCHEMA,
} from './decisionRationale';

export { pathsNotTaken } from './pathsNotTaken';

export {
    getWorkspaceKey,
    getActiveWeights,
    setActiveWeights,
    clearActiveWeights,
    hasActiveOverride,
} from './rankerWeightsState';
